import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { BlobProvider } from '@react-pdf/renderer';
import print from 'print-js';
import Button from '@material-ui/core/Button';
import PrintIcon from '@material-ui/icons/Print';
import UmslagToPdf from 'pages/skraning/atkvaedi/components/print/umslag/UmslagToPdf';

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing()
  }
}));

const PrintUmslag = ({ kjosandi, kosning }) => {
  const classes = useStyles();

  // Works in Chrome, Edge Chromium
  // Atm, Firefox opens the pdf in a new tab
  // Broken in MS Edge (Access denied)
  const handlePrint = url => e => {
    print(url, 'pdf')
  }

  return (
    <BlobProvider
      document={<UmslagToPdf kjosandi={kjosandi} activeKosning={kosning} />}
    >
      {({ url }) => (
        <Button color="primary" variant="contained" onClick={handlePrint(url)}>
          <PrintIcon className={classes.icon} />
          Prenta umslag
        </Button>
      )}
    </BlobProvider>
  );
}

export default PrintUmslag;